// extracted by mini-css-extract-plugin
export default {"BetaBadge":"BetaBadge_BetaBadge__eI6VX"};